export default "__VITE_ASSET__Bx76eL$7__"